export default {
    backend: process.env.BACKEND_URL || "http://localhost:7093/",
    portal: process.env.PORTAL_URL || "/portal",
    auth: process.env.AUTH_URL || "",
    groove: process.env.GROOVE_CHAT_ID || ""
}